export interface ProductVideoPlaybackState {
  active: boolean
  visible: boolean
  pageVisible: boolean
  hovered: boolean
}

export function createProductVideoPlayback(
  video: Pick<HTMLVideoElement, 'muted' | 'play' | 'pause'>,
  autoplay: boolean,
) {
  let manual = false
  let disposed = false
  let canPlay = false
  let wantsPreview = false

  async function play(preview: boolean) {
    if (preview) video.muted = true
    try {
      await video.play()
      // A pending play request can finish after scrolling or unmounting.
      if (disposed || !canPlay || (!manual && !wantsPreview)) {
        video.pause()
      }
    }
    catch {
      // Native controls remain available when the browser denies autoplay.
    }
  }

  return {
    update(state: ProductVideoPlaybackState) {
      if (disposed) return

      canPlay = state.active && state.visible && state.pageVisible
      const previousPreview = wantsPreview
      wantsPreview = canPlay && (autoplay || state.hovered)

      if (!canPlay || (!manual && !wantsPreview)) {
        video.pause()
      }
      else if (!manual && wantsPreview && !previousPreview) {
        void play(true)
      }
    },
    takeManualControl() {
      manual = true
    },
    async playManually() {
      manual = true
      if (!disposed && canPlay) await play(false)
    },
    dispose() {
      disposed = true
      video.pause()
    },
  }
}
